module.exports = __webpack_public_path__ + "static/media/preview.80aa8657.png";